<template>
  <vs-popup ref="batch-popup" class="holamundo" title="Batch Lookup" :active.sync="tmpActive">
    <div class="vx-col w-full px-8">
      <div class="vx-row mb-5">
        <label>Select batch</label>
        <select-2 autocomplete class="w-full" :value="batch && batch.id" @input="(item) => (batch = item)" placeholder="Select Batch" action="batch/getBatchOptions" />
      </div>

      <vs-table
        v-if="form.categoryId === categories.PLANT || form.categoryId === categories.MATURE"
        v-model="selected"
        multiple
        id="table-loading"
        ref="table-loading"
        class="vs-con-loading__container mb-5"
        stripe
        :data="computedPlants"
        :total="computedPlants.length"
      >
        <template slot="thead">
          <vs-th>Serial No.</vs-th>
        </template>

        <template slot-scope="{ data }" ref="tableBody">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ `${tr.serialNumber} - (${tr.plant_name})` }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <div class="vx-row justify-center">
        <vs-button @click="addBatch" type="relief">Save</vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

import Select2 from '@/components/custom/form-elements/Select2.vue'

export default {
  name: 'BatchModal',
  components: {
    Select2
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object
    }
  },

  data() {
    return {
      tmpActive: this.active,
      selected: [],
      plants: [],
      loading: false,
      loaded: false
    }
  },

  mounted() {
    if (this.form.batchId && this.form.batchNumber) {
      this.getBatchPlants()
    }
  },

  computed: {
    ...mapState('product', ['categories', 'product']),

    batch: {
      get() {
        return { id: this.form.batchId, batch_number: this.form.batchNumber }
      },
      async set(val) {
        this.$emit('update:form', {
          ...this.form,
          batchId: val.id,
          batchNumber: val.batch_number
        })
      }
    },

    // plant list
    computedPlants() {
      return [
        // batch palnts
        ...this.plants.map((i) => ({
          id: i.id,
          serialNumber: i.serialNumber,
          plant_name: i.plant_name
        })),

        // product plants ( for edit product )
        ...((this.product && this.product.product_plants) || []).reduce((coll, i) => {
          const ii = {
            id: i.plant ? i.plant.id : i.id,
            serialNumber: i.plant ? i.plant.serialNumber : i.serialNumber,
            plant_name: i.plant ? i.plant.plant_name : i.plant_name
          }
          if (Object(i).hasOwnProperty('status') && i.status) {
            coll.push(ii)
          }
          return coll
        }, [])
      ]
    }
  },

  methods: {
    ...mapActions('batch', ['getAllPlantsForLookUp']),
    ...mapMutations('product', { setState: 'SET_STATE' }),

    addBatch() {
      if (this.batch.id) {
        this.$emit('added', {
          batch_number: this.batch.batch_number,
          plants: this.selected.reduce((acc, item) => {
            const sr_no = item.serialNumber
            if (acc.findIndex((x) => x === sr_no) === -1) {
              acc.push({
                serialNumber: sr_no,
                plantId: item.id
              })
            }

            return acc
          }, [])
        })
      }
      this.tmpActive = false
    },

    // get batch plants
    async getBatchPlants() {
      if ((this.form.categoryId === this.categories.PLANT || this.form.categoryId === this.categories.MATURE) && this.batch.id) {
        try {
          this.loading = true
          const { data } = await this.getAllPlantsForLookUp({
            id: this.batch.id,
            action: 'unassigned_plant'
          })

          this.loading = false
          this.plants = data
        } catch (e) {
          this.loading = false
        }
      }
    }
  },

  watch: {
    async 'form.batchId'() {
      await this.getBatchPlants()
    },

    loading() {
      if (!this.$refs['table-loading'] || this.form.categoryId !== this.categories.PLANT || this.form.categoryId !== this.categories.MATURE) return
      if (this.loading) {
        this.$vs.loading({
          container: '#table-loading',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#table-loading > .con-vs-loading')
      }
    },

    active() {
      this.tmpActive = this.active
    },

    async tmpActive() {
      if (this.tmpActive) {
        // eslint-disable-next-line no-extra-semi
        ;((this.product && this.product.product_plants) || []).forEach((i) => {
          const ii = {
            id: i.plant ? i.plant.id : i.id,
            serialNumber: i.plant ? i.plant.serialNumber : i.serialNumber,
            plant_name: i.plant ? i.plant.plant_name : i.plant_name
          }

          this.selected.push(this.computedPlants.find((x) => x.serialNumber === ii.serialNumber))
        }, [])
      }

      this.$emit('update:active', this.tmpActive)
    }
  },

  beforeRouteLeave(_, __, next) {
    this.tmpActive = false
    next()
  }
}
</script>
